import { Chart } from 'react-google-charts';
import { useEffect, useState } from 'react';
import { ApiConsumer } from 'api/ApiConsumer';
import Loader from 'components/Loader';

const noop = function () {};

const getLimitedResult = (list, limitFilter) => {
  if (limitFilter == 'all') {
    return list;
  } else {
    return list.slice(0, limitFilter + 1);
  }
};

Doughnut.defaultProps = {
  height: '400px',
  url: '',
  onDataLoad: noop,
  normaliseData: (data) => data,
};

export function Doughnut({
  url,
  height,
  onDataLoad,
  normaliseData,
  className,
  colors
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    ApiConsumer.get(url)
      .then((res) => {
        setData(normaliseData(res.data));
      })
      .catch(() => onDataLoad(false))
      .finally(() => setLoading(false));
  }, [url]);

  let options = {};
  if (colors){
    options = {
      title: '',
      pieHole: 0.4,
      is3D: false,
      legend: { position: 'bottom' },
      colors: colors
    };
  }
  else{
    options = {
      title: '',
      pieHole: 0.4,
      is3D: false,
      legend: { position: 'bottom' }
    };
  }

  return (
    <>
      {loading ? (
        <Loader upload_message={'loading'} full_height={true} />
      ) : (
        <Chart
          chartType="PieChart"
          width="100%"
          height={height}
          data={data}
          options={options}
          className={'shadow rounded'}
        />
      )}
    </>
  );
}
